export const handleSetPermissions = (
  confirmPageSection,
  team,
  fetchPermissionSet,
  updateConfirmPageSection
) => {
  var permissionSetToFetch;
  if(confirmPageSection.permission_set_id){
    permissionSetToFetch = {
      id: confirmPageSection.permission_set_id
    };
  } else {
    permissionSetToFetch = {
      element_id: confirmPageSection.id,
      element_type: "ConfirmPageSection"
    };
  }

  permissionSetToFetch = Object.assign({}, permissionSetToFetch, {
    _element_type_human_name: "Page Section"
  });

  fetchPermissionSet(team, permissionSetToFetch, (permissionSet) => {
    var updated = Object.assign({}, confirmPageSection, {
      permission_set_id: permissionSet.id
    });
    updateConfirmPageSection(updated);
  });
};

